import React from 'react'
import BannerImg from '../../assets/bg_image.webp'
import { Link } from 'react-router-dom'
import { MdArrowOutward } from 'react-icons/md'
import { banner_traveller } from '../../assets/updated_assests/assets'
const Banner = () => {
    return (
        <div>
            <div className="banner min-h-[700px] w-full !bg-cover !bg-center !bg-no-repeat text-center" style={{
                background: `url(${banner_traveller})`,

            }} >
                <div className="grid bg-[#25231B80] md:grid-cols-5  grid-cols-1 min-h-[700px]">
                    <div className=" w-full min-h-[700px] flex col-span-2 justify-center items-end p-4 md:pl-12">
                        <div className="">
                            <h3 className='text-white text-left font-roboto-mono font-bold italic md:text-[2.5rem] text-[1.8rem]' >
                                We Are Travelers
                            </h3>
                            <p className='text-white font-quicksand font-medium text-[16px] text-left mb-6 ' >Every destination shaped our vision, each journey inspired us to reimagine travel gear. Now we’re transforming the way adventurers explore the world</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Banner
